import {Inject, Injectable} from '@angular/core';
import {HttpRequest, HttpHandler, HttpEvent, HttpInterceptor, HttpHeaders} from '@angular/common/http';
import { Observable } from 'rxjs';
import {JwtHelperService} from '@auth0/angular-jwt';
import {AppConfig} from '../app.config';

// case insensitive check against config and value
const startsWithAny = (arr: string[] = []) => (value = '') => {
  return arr.some(test => value.toLowerCase().startsWith(test.toLowerCase()));
};

// http, https, protocol relative
const isAbsoluteURL = startsWithAny(['assets']);


@Injectable()
export class HttpClientInterceptor implements HttpInterceptor {


  private baseUrl : string;

  constructor(private jwtHelper: JwtHelperService, private appConfig : AppConfig) {
  }



  intercept(request: HttpRequest<any>, newRequest: HttpHandler): Observable<HttpEvent<any>> {

    if (isAbsoluteURL(request.url)) {
      return newRequest.handle(request);
    }

    //this.baseUrl = this.appConfig.getApiAddress();
    //let apiReq = request.clone({ url: `${this.baseUrl}${request.url}` });
    let apiReq = request.clone();

    // Get Token data from local storage
    const tokenInfo = localStorage.getItem('TokenInfo');

    if (tokenInfo && !this.jwtHelper.isTokenExpired(tokenInfo)) {
      /*if (apiReq.url.indexOf('upload') > -1) {
        apiReq = apiReq.clone({
          headers: new HttpHeaders({
            Authorization: `Bearer ${tokenInfo}`,
            'Cache-Control': 'no-cache',
            'Pragma': 'no-cache'
          })
        });
      } else {
        apiReq = apiReq.clone({
          headers: new HttpHeaders({
            Authorization: `Bearer ${tokenInfo}`,
            'Content-Type': 'application/json',
            'Cache-Control': 'no-cache',
            'Pragma': 'no-cache'
          })
        });
      }*/

      apiReq = apiReq.clone({
        headers: new HttpHeaders({
          Authorization: `Bearer ${tokenInfo}`,
          // 'Content-Type': 'application/json',
          'Cache-Control': 'no-cache',
          'Pragma': 'no-cache'
        })
      });
    }


    return newRequest.handle(apiReq);
  }
}
